import { createContext } from 'react';
import type { Locale } from './translations';

export interface LocaleContextValue {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

export const LocaleContext = createContext<LocaleContextValue | undefined>(undefined);

